import { Button } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import History from '../../../components/history/';
import Upload from '../../recept/register/upload';
import { FORMAT_DATE } from '../../../configure/systemConfig';

export default function XemHoSo(props) {
    const [patient, setPatient] = useState({});
    useEffect(() => {
        setPatient(props.patient);
    }, [props.patient])
    return <React.Fragment>
        <div className="h3 font-weight-bold text-center text-uppercase">Hồ sơ khám</div>
        <div className="row">
            <div className="col-md-6 my-1">
                Mã BN: <strong className="ml-2">{patient.patientID}</strong>
            </div>
            <div className="col-md-6 my-1">
                Họ tên:<strong className="ml-2">{patient.patientName}</strong>
            </div>
            <div className="col-md-6 my-1">
                {patient.onlyyear ? "Năm sinh" : "Ngày sinh"}:<strong className="ml-2">{patient.onlyyear ? moment(patient.birthDay).format("YYYY") : moment(patient.birthDay).format(FORMAT_DATE)}</strong>
            </div>
            <div className="col-md-6 my-1">
                Giới tính:<strong className="ml-2">{patient.gender === 0 ? 'Nam' : 'Nữ'}</strong>
            </div>
            <div className="col-md-6 my-1">
                Điện thoại:<strong className="ml-2">{patient.phone}</strong>
            </div>
            <div className="col-md-6 my-1">
                Email:<strong className="ml-2">{patient.email}</strong>
            </div>
        </div>
        <div className="border-register">
            <div style={{ cursor: 'pointer' }} data-toggle="collapse" data-target="#lichsukham" className="h4 font-weight-bold" id="btn-lichsukham">
                Lịch sử khám
            </div>
            <div id="lichsukham" className="collapse show" style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                {patient.patientID &&
                    <History iShowResult={true} patientID={patient.patientID}></History>
                }
            </div>
        </div>
        <div className="border-register">
            <div style={{ cursor: 'pointer' }} data-toggle="collapse" data-target="#fileupload" className="h4 font-weight-bold" id="btn-fileupload">
                Hồ sơ
            </div>
            <div id="fileupload" className="collapse" style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                <Upload
                    patientid={patient.patientID}
                    isUpload={true}
                />
            </div>
        </div>
        <div className="text-center mt-2">
            <Button onClick={() => props.onClose()}>Đóng</Button>
        </div>
    </React.Fragment>
}